import * as banners from "./banners";
import * as logos from "./logos";
import * as setting from "./setting";
import * as partners from "./partners";
import * as popups from "./popups";

export const common = {
    ...banners,
    ...logos,
    ...setting,
    ...partners,
    ...popups
}